import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCircleUnread } from '@/hooks/useCircleUnread';

export const NotificationBell = ({ className = '' }) => {
  const navigate = useNavigate();
  const { unreadCount, hasUnread, isSubscriber, markVisited } = useCircleUnread();

  if (!isSubscriber) return null;

  const handleClick = async () => {
    await markVisited();
    navigate('/circle');
  };

  return (
    <button
      onClick={handleClick}
      className={`relative p-2 rounded-full transition-all duration-200 active:scale-95 ${className}`}
      data-testid="nav-circle"
      aria-label={`The Circle${hasUnread ? ` - ${unreadCount} new notifications` : ''}`}
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#A9756B" strokeWidth="1.5">
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="10" r="3" />
        <path d="M6.5 18.5c0-3 2.5-4.5 5.5-4.5s5.5 1.5 5.5 4.5" />
      </svg>

      {hasUnread && (
        <span
          className="absolute -top-0.5 -right-0.5 flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold text-[#1A1A2E] rounded-full animate-pulse"
          style={{
            background: 'linear-gradient(135deg, #C9A84C 0%, #e8b4b8 100%)',
            boxShadow: '0 0 8px rgba(201,168,76,0.6)'
          }}
          data-testid="notification-badge"
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
};
